import { validate } from 'revalidator';

export default function validateLogIn (form) {
	return validate(form, {
		type: 'object',
		properties: {
			vin: {
				type: 'string',
				required: true,
				allowEmpty: false,
				conform: vin => (/^[A-Z0-9]+$/).test(vin.toUpperCase()) && vin.trim().length <= 25,
				messages: {
					allowEmpty: 'fieldIsRequired',
					conform: 'enterValidVin'
				}
			},

			accountNo: {
				type: 'string',
				required: true,
				allowEmpty: false,
				messages: {
					allowEmpty: 'fieldIsRequired'
				}
			}
		}
	});
}
